import { DeviceStorageManager } from "@react/ionic/storage";

import { DATABASE_NAME, TABLE_NAME } from "./storage.ts";

export const deviceStorage = new DeviceStorageManager({
  database: DATABASE_NAME,
  tables: [TABLE_NAME],
  version: 2,
});
